/* eslint no-use-before-define: 0 */

const PhonePasswordLogin = {
  id: 1,
  title: "登录",
  inputOne: {
    placeholder: "请输入手机号",
    className: "phone",
    id: "phone",
    name: "phone",
    errmsg: "请输入合法的手机号"
  },
  inputTwo: {
    placeholder: "请输入登录密码",
    className: "password",
    name: "password",
    id: "password",
    errmsg: "密码错误"
  },
  buttonText: {
    content: "登录",
    linkto: ""
  },
  tips: {
    className: "tips-one",
    one: {
      content: "验证码登录/注册",
      updateState: "#/login?id=2"
    },
    two: {
      content: "忘记密码?",
      updateState: "#/login?id=6"
    }
  }
};

const VerificatePhoneLogin = {
  id: 2,
  title: "验证码登录/注册",
  inputOne: {
    placeholder: "请输入手机号",
    className: "phone",
    name: "bindPhone",
    id: "phone",
    errmsg: "请输入合法的手机号"
  },
  inputTwo: {
    placeholder: "短信验证码",
    className: "message-code",
    id: "messageCode",
    name: "messageCode",
    errmsg: "验证码错误"
  },
  buttonText: {
    content: "登录",
    linkto: ""
  },
  tips: {
    className: "tips-two",
    one: {
      content: "密码登录",
      updateState: "#/login?id=1"
    }
  }
  // tips: {
  //   className: "tips-two",
  //   one: {
  //     content: "密码登录",
  //     updateState: "#/login?id=1"
  //   },
  //   two: {
  //     content: "忘记密码?",
  //     updateState: "#/login?id=6"
  //   }
  // }
};

const SetPassword = {
  id: 3,
  titleBig: "设置密码",
  titleSmall: "该选项不是必填，可点击下方跳过",
  inputOne: {
    placeholder: "至少6位数字、字母组合",
    className: "password",
    id: "password",
    name: "setPassword",
    errmsg: "密码错误"
  },
  buttonText: {
    content: "保存",
    linkto: ""
  },
  tips: {
    className: "tips-two",
    one: {
      content: "跳过>",
      updateState: "#/login?id=8"
    }
  }
};

const BindPhone = {
  id: 4,
  title: "绑定手机",
  inputOne: {
    placeholder: "请输入手机号",
    className: "phone",
    name: "bindPhone",
    id: "phone",
    errmsg: "请输入合法的手机号"
  },
  inputTwo: {
    placeholder: "短信验证码",
    className: "message-code",
    id: "messageCode",
    name: "messageCode",
    errmsg: "验证码错误"
  },
  buttonText: {
    content: "绑定",
    linkto: ""
  }
};

const WeixinLogin = {
  id: 5
  // title: '微信登录',
};

const ForgetPassword = {
  id: 6,
  title: "找回密码",
  inputOne: {
    placeholder: "请输入手机号",
    className: "phone",
    id: "phone",
    errmsg: "请输入合法的手机号"
  },
  inputTwo: {
    placeholder: "短信验证码",
    className: "message-code",
    id: "messageCode",
    errmsg: "验证码错误"
  },
  buttonText: {
    content: "下一步",
    linkto: "",
    updateState: "#/login?id=7"
  },
  tips: {
    className: "tips-two",
    one: {
      content: "密码登录",
      updateState: "#/login?id=1"
    }
  }
};

const ResetPassword = {
  id: 7,
  title: "重置密码",
  inputOne: {
    placeholder: "至少6位数字、字母组合",
    className: "password",
    id: "passwordOne",
    name: "resetPassword1",
    errmsg: "密码错误"
  },
  inputTwo: {
    placeholder: "至少6位数字、字母组合",
    className: "password",
    id: "passwordTwo",
    name: "resetPassword2",
    errmsg: "密码错误"
  },
  buttonText: {
    content: "保存",
    linkto: ""
  },
  tips: {
    className: "tips-two",
    one: {
      content: "密码登录",
      updateState: "#/login?id=1"
    }
  }
};

const LoginSuccess = {
  id: 8,
  titleBig: "恭喜您，注册成功",
  buttonText: {
    content: "首页"
  },
  success: true
};


export const LoginData = {
  PhonePasswordLogin,
  VerificatePhoneLogin,
  SetPassword,
  BindPhone,
  ForgetPassword,
  WeixinLogin,
  ResetPassword,
  LoginSuccess
};



// WEBPACK FOOTER //
// ./src/utils/Login.js